export const createDatePicker = (callback) => {
    // eslint-disable-next-line quotes
    $('input[name="daterange"]').daterangepicker(
        {
            opens: "right",
            autoApply: true,
            autoUpdateInput: true,
            showDropdowns: true,
            alwaysShowCalendars: true,
            applyButtonClasses: "btn-primary",
            cancelClass: "btn-light",
            minYear: moment("2000").year(),
            maxYear: moment().year(),
            minDate: moment("2000-01-01"),
            maxDate: moment().endOf("year"),
            startDate: moment(),
            endDate: moment(),
            ranges: {
                Hoy: [moment(), moment()],
                "Ultimos 7 dias": [moment().subtract(6, "days"), moment()],
                "Ultimos 30 dias": [moment().subtract(29, "days"), moment()],
                "Ultimos 6 Meses": [moment().subtract(6, "month"), moment()],
                "Ultimo año": [moment().subtract(12, "month"), moment()],
                Todo: [moment("2000-01-01"), moment()],
                "Mes actual": [
                    moment().startOf("month"),
                    moment().endOf("month"),
                ],
            },
            locale: {
                format: "DD/MM/YYYY",
                separator: " - ",
                applyLabel: "Seleccionar",
                cancelLabel: "Cancelar",
                fromLabel: "Desde",
                toLabel: "Hasta",
                customRangeLabel: "Personalizado",
                weekLabel: "S",
                firstDay: 1,
                // eslint-disable-next-line no-underscore-dangle
                monthNames: moment()
                    .locale(0)
                    ._locale._months.map(
                        (month) => month.charAt(0).toUpperCase() + month.slice(1),
                    ),
                // eslint-disable-next-line no-underscore-dangle
                daysOfWeek: moment().locale(0)._locale._weekdaysMin,
            },
        },
        callback,
    );
};
